import React from 'react';
import { Link } from 'react-router-dom';

export function getInvestorProfilePath(investorUuid, partnerUuid) {
  const id = String(investorUuid || '').trim();
  if (!id) return null;
  const base = `/investors/${encodeURIComponent(id)}/profile`;
  const partnerId = String(partnerUuid || '').trim();
  if (!partnerId) return base;
  return `${base}?partner_uuid=${encodeURIComponent(partnerId)}`;
}

export function getPartnerDetailsPath(partnerUuid) {
  const id = String(partnerUuid || '').trim();
  if (!id) return null;
  return `/partner/details/${encodeURIComponent(id)}`;
}

export function getSupplierProfilePath(supplierUuid) {
  const id = String(supplierUuid || '').trim();
  if (!id) return null;
  return `/suppliers/${encodeURIComponent(id)}/profile`;
}

export function resolveInvestorUuid(row) {
  return row?.investor_uuid ?? row?.investor?.uuid ?? row?.investor?.id ?? '';
}

export function resolvePartnerUuid(row) {
  return row?.partner_uuid ?? row?.partner?.uuid ?? row?.partner?.id ?? '';
}

const LINK_CLS =
  'text-primary underline decoration-primary/50 underline-offset-2 hover:text-primary/80 hover:decoration-primary cursor-pointer transition-colors';

export function ProfileLink({ to, children, className = '' }) {
  if (!to) {
    return <span className={className}>{children}</span>;
  }
  return (
    <Link
      to={to}
      className={`${LINK_CLS} ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Link>
  );
}
